import React, { ReactNode } from "react"
import { ErrorMessage, Field, FieldProps } from "formik"
import { ChipField } from "~/ui-rtk/components/ui/controls/ChipField"

type TChipsFormFieldProps = {
  id: string
  type?: string
  isError?: boolean
  className?: string
  placeholder?: string
  label?: string
  icon?: ReactNode
  appendNode?: ReactNode
}

const ChipsFormField: React.FC<TChipsFormFieldProps> = ({
  id,
  label,
  isError = false,
  placeholder,
}) => {
  const renderChipsInput = ({ field, form }: FieldProps) => (
    <ChipField
      {...field}
      classes={{
        container: "bg-white",
        input: "text-black",
        chip: {
          container: "bg-purple font-medium",
        },
      }}
      placeholder={placeholder}
      onChange={async value => await form.setFieldValue(id, value)}
    />
  )

  return (
    <div className="relative flex-auto w-full">
      {label ? (
        <label className="text-white px-0.5 text-3.5 leading-4 tracking-[-1%] font-semibold">
          {label}
        </label>
      ) : null}
      <Field id={id} name={id}>
        {renderChipsInput}
      </Field>
      {isError ? (
        <ErrorMessage
          name={id}
          component="a"
          className="absolute left-0 input-error-message"
        />
      ) : null}
    </div>
  )
}

export default ChipsFormField
